/**
 * @param data
 * @return true | false
 */
export const nullChecker = (data : string) => {
  return (typeof data !== 'undefined' && data) ? data : '';
}